export default "__VITE_ASSET__BUrypqnV__"